module.exports = __webpack_public_path__ + "img/specular-480-60.ef027eba.jpg";